import axios from '@/libs/http'

/**
 * 获取分类列表
 */
export const getCategoryList = (itemType) => {
    return axios.request({
        url: '/s/category/list',
        params:{
            itemType
        },
        method: 'GET'
    })
}
